import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { ChevronLeft, AlertTriangle, Mail, LogIn } from "lucide-react";
import { Button } from "../components/ui/button";

export default function DeleteAccountPage() {
  const { t } = useTranslation("legal");

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6" data-testid="back-to-home">
            <ChevronLeft className="h-4 w-4 mr-1" />
            {t("back")}
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 mb-2">{t("deleteTitle")}</h1>
        <p className="text-slate-600 mb-8">{t("deleteIntro")}</p>

        <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <div className="flex items-start gap-3 mb-3">
              <LogIn className="h-6 w-6 text-omu-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-xl font-semibold text-slate-900 mb-2">{t("deleteMethod1Title")}</h2>
                <p>{t("deleteMethod1Intro")}</p>
                <ol className="list-decimal list-inside mt-2 space-y-1">
                  <li>{t("deleteMethod1Step1")} <a href="https://www.omudoc.com" className="text-omu-blue-500 underline">www.omudoc.com</a></li>
                  <li><Trans i18nKey="deleteMethod1Step2" ns="legal" components={{ strong: <strong /> }} /></li>
                  <li><Trans i18nKey="deleteMethod1Step3" ns="legal" components={{ strong: <strong /> }} /></li>
                  <li><Trans i18nKey="deleteMethod1Step4" ns="legal" components={{ strong: <strong /> }} /></li>
                  <li><Trans i18nKey="deleteMethod1Step5" ns="legal" components={{ strong: <strong /> }} /></li>
                  <li><Trans i18nKey="deleteMethod1Step6" ns="legal" components={{ strong: <strong /> }} /></li>
                  <li><Trans i18nKey="deleteMethod1Step7" ns="legal" components={{ strong: <strong /> }} /></li>
                </ol>
              </div>
            </div>
          </section>

          <hr className="border-slate-200" />

          <section>
            <div className="flex items-start gap-3 mb-3">
              <Mail className="h-6 w-6 text-omu-blue-500 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-xl font-semibold text-slate-900 mb-2">{t("deleteMethod2Title")}</h2>
                <p>{t("deleteMethod2Intro")}</p>
                <div className="mt-3 p-4 bg-slate-50 rounded-xl border border-slate-200">
                  <p className="text-slate-900 font-semibold text-lg" data-testid="delete-account-email">
                    wo.consulting@hotmail.com
                  </p>
                </div>
                <p className="mt-3"><strong>{t("deleteMethod2EmailHint")}</strong></p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li><Trans i18nKey="deleteMethod2Item1" ns="legal" components={{ em: <em /> }} /></li>
                  <li>{t("deleteMethod2Item2")}</li>
                  <li>{t("deleteMethod2Item3")}</li>
                  <li>{t("deleteMethod2Item4")}</li>
                </ul>
                <p className="mt-3 text-sm text-slate-600">
                  <Trans i18nKey="deleteMethod2Delay" ns="legal" components={{ strong: <strong /> }} />
                </p>
              </div>
            </div>
          </section>

          <hr className="border-slate-200" />

          <section>
            <div className="flex items-start gap-3 mb-3">
              <AlertTriangle className="h-6 w-6 text-red-500 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-xl font-semibold text-slate-900 mb-2">{t("deleteDataTitle")}</h2>
                <p>{t("deleteDataIntro")}</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>{t("deleteDataItem1")}</li>
                  <li>{t("deleteDataItem2")}</li>
                  <li>{t("deleteDataItem3")}</li>
                  <li>{t("deleteDataItem4")}</li>
                  <li>{t("deleteDataItem5")}</li>
                </ul>
                <p className="mt-3">{t("deleteDataPharmacy")}</p>
                <p className="mt-3 text-red-600 font-medium">{t("deleteDataWarning")}</p>
              </div>
            </div>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("deleteRetentionTitle")}</h2>
            <p>{t("deleteRetentionP1")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("deleteQuestionsTitle")}</h2>
            <p>
              {t("deleteQuestionsP1")}{" "}
              <a href="mailto:wo.consulting@hotmail.com" className="text-omu-blue-500 underline">wo.consulting@hotmail.com</a>.
            </p>
          </section>
        </div>

        <p className="text-center text-sm text-slate-400 mt-8">{t("footerCredit")}</p>
      </div>
    </div>
  );
}
